/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {BaseSyntheticEvent, FC, ReactNode, useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import {useNavigate, useParams} from 'react-router-dom'
import {GET, POST, PUT} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import useAuth from '../../../../hooks/useAuth'
import {i18n} from '../../../../translate/i18n'
import uuid from 'react-uuid'
import 'cropperjs/dist/cropper.css'
import {ModalImagemCropped} from '../../../../components/Modals/ImagemCropped/ImagemCropped'
import useModals from '../../../../hooks/useModals'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import {ContentModalImageIA, ImageIAResponseType} from '../../../../components/ContentModalImageIA'
import {ContentModalDescriptionIA} from '../../../../components/ContentModalDescriptionIA'

import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import usePluginSpace from '../../../../hooks/usePluginSpace'
import {MeasurementGuideModal} from '../../../../components/MeasurementGuideModal/MeasurementGuideModal'
import {CardInfoGuide, CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'
import {
  productClassificationInfo,
  productDescriptionInfo,
  productExtraImagesInfo,
  productGroupsInfo,
  productGuideInfo,
  productIdentificationInfo,
  productImageInfo,
  productStatusInfo,
  productVisibilityPeriodInfo,
} from './productCardInfoContent'
import './modal-custom.css'

type ProductType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
}

type ImageType = {
  id: number
  productId: string
  path: string
  imgsuffix: string
  typeimg: string
}

type ImageCreateType = {
  path: string
  productId?: string
  typeimg: string
  order: number
}

type ReturnType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
}

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type TemplateType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  typeIntegration: string
  able: boolean | null
}

type SelectType = {
  value: string | number
  label: string
}

type CollapsibleCardProps = {
  title: string
  children: ReactNode
  defaultOpen?: boolean
  infoContent?: CardInfoContent
  infoInteraction?: 'click' | 'hover' | 'both'
}

const CollapsibleCard: FC<CollapsibleCardProps> = ({
  title,
  children,
  defaultOpen = true,
  infoContent,
  infoInteraction = 'click',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className='card pb-5 mb-5'>
      <div className='card-header py-5 d-flex justify-content-between align-items-center'>
        <h3 className='card-title align-items-start flex-column mb-0'>
          <span className='card-label fw-bold fs-4 mb-1'>{title}</span>
        </h3>
        <div className='d-flex align-items-center gap-2'>
          {infoContent && <CardInfoGuide content={infoContent} interaction={infoInteraction} />}
          <button
            type='button'
            className='btn btn-sm btn-icon product-card-toggle'
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? 'Fechar card' : 'Abrir card'}
          >
            <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
          </button>
        </div>
      </div>
      <div
        style={{
          maxHeight: isOpen ? '2800px' : '0px',
          opacity: isOpen ? 1 : 0,
          overflow: isOpen ? 'visible' : 'hidden',
          transition: 'max-height 0.35s ease, opacity 0.25s ease',
        }}
      >
        <div className='px-10 py-5'>{children}</div>
      </div>
    </div>
  )
}

interface CustomerGroup {
  id: number
  pluginspaceId: number
  name: string
  created: string
  updated: string | null
  deleted: string | null
}

interface GroupResponseData {
  id: string
  pluginspaceId: number
  productId: number
  customerGroupId: number
  createdAt: string | null
  deletedAt: string | null
  customerGroup: CustomerGroup
}

// Funções auxiliares para converter entre formatos de data
const convertMaskedToISO = (maskedDate: string): string | null => {
  // Retorna null se vazio ou espaços em branco
  if (!maskedDate || maskedDate.trim() === '') return null

  // Remove espaços em branco extras
  const cleaned = maskedDate.trim()

  // Verifica se tem pelo menos o formato mínimo: DD/MM/YYYY HH:MM
  if (cleaned.length < 16) return null

  try {
    // Extrai as partes: DD/MM/YYYY HH:MM
    const parts = cleaned.match(/(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})/)

    if (!parts || parts.length < 6) return null

    const day = parts[1]
    const month = parts[2]
    const year = parts[3]
    const hour = parts[4]
    const minute = parts[5]

    // Validação básica dos valores
    const dayNum = parseInt(day)
    const monthNum = parseInt(month)
    const yearNum = parseInt(year)
    const hourNum = parseInt(hour)
    const minuteNum = parseInt(minute)

    if (
      dayNum < 1 ||
      dayNum > 31 ||
      monthNum < 1 ||
      monthNum > 12 ||
      hourNum < 0 ||
      hourNum > 23 ||
      minuteNum < 0 ||
      minuteNum > 59
    ) {
      return null
    }

    // Cria data SEM forçar UTC - usa o timezone local do navegador
    const date = new Date(yearNum, monthNum - 1, dayNum, hourNum, minuteNum, 0)

    // Valida se a data é válida
    if (isNaN(date.getTime())) return null

    // Retorna ISO string sem adicionar Z (mantém o horário local)
    return date.toISOString()
  } catch (error) {
    console.error('Erro ao converter data:', error)
    return null
  }
}

const convertISOToMasked = (isoDate: string): string => {
  if (!isoDate) return ''
  try {
    const date = new Date(isoDate)
    if (isNaN(date.getTime())) return ''

    // Usa o timezone local do navegador para exibir
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')

    return `${day}/${month}/${year} ${hour}:${minute}`
  } catch (error) {
    console.error('Erro ao converter data para máscara:', error)
    return ''
  }
}

const EditarProdutosContent: FC = () => {
  const navigate = useNavigate()
  const {showImageCropped, showWrapperModal} = useModals()
  const {loginInfo} = useAuth()
  const {id} = useParams()
  const [listClassification, setListClassification] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const [subcategoryId, setSubCategoryId] = useState<any>('0')
  const [name, setName] = useState<string>('')
  const [code, setCode] = useState<string>()
  const [description, setDescription] = useState<string>('')
  const [technicalSpecification, setTechnicalSpecification] = useState<string>('')
  const [marks, setMarks] = useState<any[]>([])
  const [markId, setMarkId] = useState<string>('0')
  const [measurements, setMeasurements] = useState<any[]>([])
  const [measurementId, setMeasurementId] = useState<string>('')
  const [order, setOrder] = useState<string>('0')
  const [status, setStatus] = useState<boolean>(true)
  const [image, setImage] = useState<File | string | null>(null)
  const [imageGuide, setImageGuide] = useState<File | string | null>(null)

  const [imageCrop, setImageCrop] = useState<string | null>('')
  const [isCropped, setCropper] = useState<any>(null)
  const {useTotvs} = usePluginsSpace()
  const [firstStateImage, setFirstStateImage] = useState<File | string | null>(null)
  const [originalImageFile, setOriginalImageFile] = useState<File | null>(null) // Nova variável para armazenar a imagem original
  const [imagesProducts, setImagesProducts] = useState<ImageType[]>([])
  const [extraImages, setExtraImages] = useState<FileList>()
  const [extraImagesUrl, setExtraImagesUrl] = useState<ImageType[]>([])
  const [deletedImages, setDeletedImages] = useState<number[]>([])
  const [disableFieldsTotvs, setDisableFieldTotvs] = useState(false)
  const [pluginIA, setPluginIA] = useState('')
  const [showDescriptionIAModal, setShowDescriptionIAModal] = useState(false)
  const [showMeasurementGuideModal, setShowMeasurementGuideModal] = useState(false)
  const [imageIaSelected, setImageIaSelected] = useState<ImageIAResponseType>()
  const [canAlert, setCanAlert] = useState(false)
  const [saleDateStart, setSaleDateStart] = useState<string>('')
  const [saleDateEnd, setSaleDateEnd] = useState<string>('')

  /** Variavel usada para saber se é atacado */
  const {getPluginSpace} = usePluginSpace()
  const [isWholeSaler, setIsWholeSaler] = useState(false)
  /** Caso seja atacado, recuperar grupos e grupos associados a esse produto */
  const [groups, setGroups] = useState<
    {
      created: string
      deleted: string
      id: number
      name: string
      pluginspaceId: number
      updated: string
    }[]
  >([])
  const [groupsAssociated, setGroupsAssociated] = useState<SelectType[]>([])

  async function getCustomersGroups() {
    try {
      const thisPluginsSpace = await getPluginSpace(true)

      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler

      if (isWholeSaler) {
        setIsWholeSaler(true)
        const res = await GET('/customer_groups')
        if (res && res.data) {
          setGroups(res.data)
        }
        const groupsAssociated = await GET(`/product-customer-group/${id}/product`)
        if (groupsAssociated && groupsAssociated.data) {
          const groupData: GroupResponseData[] = groupsAssociated.data
          setGroupsAssociated(
            groupData.map((row) => {
              return {
                value: row.customerGroupId,
                label: row.customerGroup.name,
              }
            })
          )
        }
      }
    } catch (error) {}
  }

  const generateClassificationTree = (
    categories: ReturnType[],
    parent: string | null,
    name: string
  ): any => {
    const parentCategory = categories.find((category) => category.code === parent)
    if (parentCategory)
      return `${generateClassificationTree(
        categories,
        parentCategory.parent,
        parentCategory.name
      )} > ${name}`
    else return name
  }

  const getCategories = async () => {
    try {
      const res = await GET('/classification')
      const newList = listClassification
      res.data.map((row: ProductType) => {
        newList.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: generateClassificationTree(res.data, row.parent, row.name),
        })
      })
      setListClassification(newList)
      // const cat = newList.filter(function (row) {
      //   return row.parent === null || row.parent == ''
      // })

      const categories = [
        {
          value: '0',
          select: 'Selecione',
          key: -1,
        },
      ]
      newList.map((row: any, idx) => {
        categories.push({
          value: row.id,
          select: row.name,
          key: idx,
        })
      })

      setCategories(categories)
    } catch (e) {
      console.log(e)
    }
  }

  const getMarks = async () => {
    try {
      const res = await GET('/mark')
      const marks = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data.map((row: ProductType) => {
        marks.push({
          value: row.id,
          select: row.name,
        })
      })
      setMarks(marks)
    } catch (e) {
      console.log(e)
    }
  }

  const getMeasurements = async () => {
    try {
      const res = await GET('/measurement')
      const measurements = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data.map((row: ProductType) => {
        measurements.push({
          value: row.id,
          select: row.description,
        })
      })
      setMeasurements(measurements)
    } catch (e) {
      console.log(e)
    }
  }

  const getProduct = async () => {
    setLoading(true)
    try {
      if (useTotvs) {
        setDisableFieldTotvs(true)
      }
      await getCustomersGroups()
      await getCategories()
      await getMarks()
      await getMeasurements()
      await GET(`/product/${id}`).then(async (res) => {
        const cat = listClassification.filter(
          (row) => parseInt(row.id) === parseInt(res.data[0].classificationId)
        )
        if (cat && cat[0]) {
          setSubCategoryId({
            value: cat[0].id,
            label: cat[0].name,
          })
        }
        setMarkId(res.data[0].markId)
        setMeasurementId(res.data[0].measurementUnitId)
        setName(res.data[0].name)
        setCode(res.data[0].code)
        setDescription(res.data[0].description ? res.data[0].description : '')
        setStatus(res.data[0].status)
        setOrder(res.data[0].order ?? '0')
        setImagesProducts(res.data[0].images)
        setTechnicalSpecification(
          res.data[0].technicalSpecification ? res.data[0].technicalSpecification : ''
        )
        // Carregar datas de venda
        if (res.data[0].saleDateStart) {
          setSaleDateStart(convertISOToMasked(res.data[0].saleDateStart))
        }
        if (res.data[0].saleDateEnd) {
          setSaleDateEnd(convertISOToMasked(res.data[0].saleDateEnd))
        }
        let urlProductImage = ''
        const imgProduct = res.data[0].images.find(
          (image: ImageType) => image.typeimg === 'imgsmall'
        )
        if (
          res.data[0].images &&
          res.data[0].images.length > 0 &&
          process.env.REACT_APP_AWS_S3_URL
        ) {
          if (imgProduct.path) {
            urlProductImage =
              imgProduct.path.substring(7, imgProduct.path.length) + '/' ===
              process.env.REACT_APP_AWS_S3_URL.substring(7, process.env.REACT_APP_AWS_S3_URL.length)
                ? imgProduct.path + '/' + imgProduct.imgsuffix
                : imgProduct.path
          }
        }
        const imagesAdd = res.data[0].images.filter((image: ImageType) => image.typeimg === 'image')

        setExtraImagesUrl(
          imagesAdd.map((image: ImageType) => {
            if (image && image.path && process.env.REACT_APP_AWS_S3_URL) {
              image.path =
                image.path.substring(7, image.path.length) + '/' ===
                process.env.REACT_APP_AWS_S3_URL.substring(
                  7,
                  process.env.REACT_APP_AWS_S3_URL.length
                )
                  ? image.path + '/' + image.imgsuffix
                  : image.path
            }
            return image
          })
        )

        const imageGuide = res.data[0].images.filter(
          (image: ImageType) => image.typeimg === 'guide'
        )
        setImageGuide(
          imageGuide && imageGuide[0] && imageGuide[0].path && process.env.REACT_APP_AWS_S3_URL
            ? imageGuide[0].path + '/' + imageGuide[0].imgsuffix
            : null
        )
        setFirstStateImage(urlProductImage)
        setImage(urlProductImage)
      })
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const editProduct = async () => {
    const subcategorySelected: any = subcategoryId
    try {
      if (
        !disableFieldsTotvs &&
        (subcategoryId === '0' ||
          subcategorySelected.value === '0' ||
          !name ||
          !description ||
          markId === '0' ||
          measurementId === '0')
      ) {
        setCanAlert(true)
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        setLoading(true)

        /* Fucao utilizada somente para atacado - Grupos e Produtos  */
        if (isWholeSaler) {
          await POST('/product-customer-group', {
            productId: id,
            customerGroups: groupsAssociated.map((group) => group.value),
          })
        }

        const data = {
          name: name,
          description: description,
          order: parseInt(order),
          code: code ?? '',
          classificationId: parseInt(subcategorySelected.value),
          type: 'product',
          status: status,
          measurementUnitId: parseInt(measurementId),
          parent: '',
          markId: parseInt(markId),
          technicalSpecification: technicalSpecification,
          saleDateStart: convertMaskedToISO(saleDateStart),
          saleDateEnd: convertMaskedToISO(saleDateEnd),
        }
        const resProd = await PUT(`/product/${id}`, data)
        const newDeletedImages = Object.assign(deletedImages)
        let dataImages: ImageCreateType[] = []
        if (resProd.success === true) {
          let imageRes = {
            success: false,
            image: '',
          }
          if (image && image !== firstStateImage) {
            if (firstStateImage && typeof firstStateImage === 'string') {
              await POST('/upload-images/delete-one', {
                url: firstStateImage,
              })
            }
            if (imageIaSelected?.url) {
              imageRes.success = true
              imageRes.image = image.toString()
            } else {
              const formData = new FormData()

              // Verificar se a imagem tem dados de dimensões especiais
              let actualFile = image
              if (image && typeof image === 'object' && '_formatData' in image) {
                const imageWithFormat = image as any
                if (imageWithFormat._formatData && imageWithFormat._formatData.file) {
                  actualFile = imageWithFormat._formatData.file

                  // Se tem width e height específicos (formato selecionado)
                  if (imageWithFormat._formatData.width && imageWithFormat._formatData.height) {
                    formData.append('width', imageWithFormat._formatData.width.toString())
                    formData.append('height', imageWithFormat._formatData.height.toString())
                  }

                  // Se é imagem original com dimensões naturais
                  if (
                    imageWithFormat._formatData.isOriginal &&
                    imageWithFormat._formatData.originalWidth &&
                    imageWithFormat._formatData.originalHeight
                  ) {
                    formData.append(
                      'originalWidth',
                      imageWithFormat._formatData.originalWidth.toString()
                    )
                    formData.append(
                      'originalHeight',
                      imageWithFormat._formatData.originalHeight.toString()
                    )
                    formData.append('useOriginalDimensions', 'true')
                  }
                }
              }

              formData.append('file', actualFile)
              formData.append('nameImage', `product-${uuid()}.jpg`)

              imageRes = await POST('/upload-images/upload-one-resized', formData)
            }
            imagesProducts.forEach((image) => {
              if (image.typeimg !== 'image') {
                deletedImages.push(image.id)
              }
            })
            dataImages = [
              {
                path: imageRes.image,
                productId: id,
                typeimg: 'imgsmall',
                order: 0,
              },
              {
                path: imageRes.image,
                productId: id,
                typeimg: 'mainpicture',
                order: 0,
              },
              {
                path: imageRes.image,
                productId: id,
                typeimg: 'thumbpicture',
                order: 0,
              },
            ]
          } else if (!image) {
            imagesProducts.map((image) => {
              if (image.typeimg !== 'image') {
                deletedImages.push(image.id)
              }
            })
          }
          const currentGuideImage = imagesProducts.find(
            (currentImage) => currentImage.typeimg === 'guide'
          )

          if (!imageGuide) {
            if (currentGuideImage && !deletedImages.includes(currentGuideImage.id)) {
              deletedImages.push(currentGuideImage.id)
            }
          } else if (typeof imageGuide !== 'string') {
            if (currentGuideImage && !deletedImages.includes(currentGuideImage.id)) {
              deletedImages.push(currentGuideImage.id)
            }

            let imageGuideRes = {
              success: false,
              image: '',
            }
            const formData = new FormData()
            formData.append('file', imageGuide)
            formData.append('nameImage', `product-guide-${uuid()}.jpg`)
            imageGuideRes = await POST('/upload-images/upload-one', formData)

            if (imageGuideRes.success) {
              dataImages.push({
                path: imageGuideRes.image,
                productId: id,
                typeimg: 'guide',
                order: 0,
              })
            }
          }
          if (extraImages) {
            await Promise.all(
              Array.from(extraImages).map(async (image) => {
                let imageExtraRes = {
                  success: false,
                  image: '',
                }
                const formData = new FormData()
                formData.append('file', image)
                formData.append('nameImage', `product-${uuid()}.jpg`)
                imageExtraRes = await POST('/upload-images/upload-one', formData)
                if (imageExtraRes.success === true) {
                  dataImages.push({
                    path: imageExtraRes.image,
                    productId: id,
                    typeimg: 'image',
                    order: 0,
                  })
                }
              })
            )
          }
          await POST('/productimage/multiple', {
            data: dataImages,
          })
          if (newDeletedImages && newDeletedImages.length > 0) {
            await POST(`productimage/delete-multiple`, {
              data: newDeletedImages,
            })
          }

          setLoading(false)
          setCanAlert(false)
          Swal.fire({
            icon: 'success',
            title: 'Produto atualizado',
            text: 'Produto atualizado com sucesso!',
          }).then(() =>
            navigate(
              `${loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion'}`
            )
          )
        } else {
          setCanAlert(true)
          setLoading(false)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar o produto!',
          })
        }
      }
    } catch (e) {
      setCanAlert(true)
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao cadastrar o produto!',
      })
    }
  }

  function deleteImages(id: number) {
    const newImagesUrls = extraImagesUrl.filter((image) => image.id !== id)
    const newDeletedImages = Object.assign(deletedImages)
    newDeletedImages.push(id)
    setDeletedImages(newDeletedImages)
    setExtraImagesUrl(newImagesUrls)
  }

  const getCropData = async () => {
    if (isCropped) {
      const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], 'newAvatar.png', {type: 'image/png'})
        })

      setImage(file)
      setImageCrop('')
    }
  }

  const useOriginalImage = () => {
    if (originalImageFile) {
      // Criar um objeto Image para obter as dimensões originais
      const img = new Image()
      img.onload = () => {
        const imageWithOriginalDimensions = {
          ...originalImageFile,
          _formatData: {
            file: originalImageFile,
            originalWidth: img.width,
            originalHeight: img.height,
            isOriginal: true,
          },
        }
        setImage(imageWithOriginalDimensions as any)
        // Definir o firstStateImage corretamente para evitar erro no delete-one
        if (!firstStateImage || typeof firstStateImage !== 'string') {
          setFirstStateImage(originalImageFile)
        }
        setImageCrop('')
      }
      img.src = URL.createObjectURL(originalImageFile)
    }
  }

  const useSelectedSize = (width: number, height: number) => {
    if (originalImageFile) {
      // Criar um objeto especial que mantém o arquivo original
      // e adiciona dados de width e height sem modificar o arquivo original
      const imageWithFormat = {
        ...originalImageFile,
        _formatData: {
          file: originalImageFile,
          width: width,
          height: height,
          isFormatted: true,
        },
      }

      setImage(imageWithFormat as any)
      setFirstStateImage(URL.createObjectURL(originalImageFile))
      setImageCrop('')
    }
  }

  const getImageForDisplay = () => {
    if (!image) return null

    // Se a imagem tem dados de formato especiais, retorna o arquivo original
    if (image && typeof image === 'object' && '_formatData' in image) {
      const imageWithFormat = image as any
      if (imageWithFormat._formatData && imageWithFormat._formatData.file) {
        return imageWithFormat._formatData.file
      }
    }

    // Retorna a imagem normalmente
    return image
  }

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
    localStorage.removeItem('product-edited-saved')
  }

  const getImagetoCrop = (e: any) => {
    if (e?.target.files) {
      setOriginalImageFile(e.target.files[0]) // Armazena a imagem original antes do crop
      setFirstStateImage(e.target.files[0]) // Mantém para compatibilidade
      showImageCropped()
      setImageCrop(URL.createObjectURL(e.target.files[0]))
    }
  }

  const verifyIA = async () => {
    const templateRes = await GET('/plugintemplate/ia')
    if (templateRes && templateRes.data) {
      templateRes.data.forEach((template: TemplateType) => {
        if (template.pluginconfig) {
          if (
            template.pluginconfig.content &&
            template.pluginconfig.content.able &&
            template.pluginconfig.content.able !== '0'
          ) {
            setPluginIA(template.pluginconfig.content.modelId)
          }
        }
      })
    }
  }

  const init = async () => {
    setLoading(true)
    verifyIA()
    const productSaved = localStorage.getItem('product-edited-saved')
    if (productSaved && JSON.parse(productSaved)) loadLocal()
    else await getProduct()
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    return () => {
      if (
        canAlert &&
        !window.location.pathname.includes(
          `/${
            loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion'
          }/editar/${id}`
        )
      ) {
        Swal.fire({
          title: 'Sair da página?',
          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          cancelButtonText: 'Continuar editando',
        }).then((result) => {
          if (!result.isConfirmed) {
            navigate(
              `/${
                loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion'
              }/editar/${id}`
            )
          } else {
            localStorage.removeItem('product-edited-saved')
          }
        })
      } else if (!canAlert) localStorage.removeItem('product-edited-saved')
    }
  }, [window.location.pathname, canAlert])

  const loadLocal = () => {
    const prouctSaved = localStorage.getItem('product-edited-saved')
    if (prouctSaved && JSON.parse(prouctSaved)) {
      const jsonProduct = JSON.parse(prouctSaved)
      setListClassification(jsonProduct.listClassification)
      setCategories(jsonProduct.categories)
      setSubCategoryId(jsonProduct.subcategoryId)
      setName(jsonProduct.name)
      setCode(jsonProduct.code)
      setDescription(jsonProduct.description)
      setTechnicalSpecification(jsonProduct.technicalSpecification)
      setMarks(jsonProduct.marks)
      setMarkId(jsonProduct.markId)
      setMeasurements(jsonProduct.measurements)
      setMeasurementId(jsonProduct.measurementId)
      setOrder(jsonProduct.order)
      setStatus(jsonProduct.status)
      if (typeof jsonProduct.image === 'string') setImage(jsonProduct.image)
      if (typeof jsonProduct.firstStateImage === 'string') setFirstStateImage(firstStateImage)
      setExtraImagesUrl(jsonProduct.extraImagesUrl)
      localStorage.removeItem('product-edited-saved')
    }
    setLoading(false)
  }

  const saveLocal = () => {
    localStorage.setItem(
      'product-edited-saved',
      JSON.stringify({
        listClassification,
        categories,
        subcategoryId,
        name,
        code,
        description,
        technicalSpecification,
        marks,
        markId,
        measurements,
        measurementId,
        order,
        status,
        image,
        firstStateImage,
        extraImagesUrl,
      })
    )
  }

  useEffect(() => {
    saveLocal()
  }, [
    listClassification,
    categories,
    subcategoryId,
    name,
    code,
    description,
    technicalSpecification,
    marks,
    markId,
    measurements,
    measurementId,
    order,
    status,
    image,
    firstStateImage,
    extraImagesUrl,
  ])

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
  }, [handleUnload])

  return (
    <>
      <style>{`
        .product-card-toggle {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: 1px solid #e4e6ef;
          background-color: #f8f9fa;
          color: #7e8299;
          transition: all 0.2s ease;
        }
        .product-card-toggle:hover {
          background-color: #eef3f7;
          border-color: #d7dbe2;
          color: #3f4254;
        }
        .product-card-toggle:focus {
          box-shadow: 0 0 0 0.2rem rgba(54, 153, 255, 0.12);
        }
        .product-image-column {
          min-width: 280px;
          max-width: 380px;
          width: 100%;
        }
        @media (max-width: 991.98px) {
          .product-image-column {
            min-width: 100%;
            max-width: 100%;
          }
        }
      `}</style>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{`${i18n.t(
                  `general.edit`
                )} ${i18n.t(`smart_order.product`)}`}</span>
                <BreadCrumbs />
              </h3>
            </div>
            <div className='card-body'>
              <div className='d-flex justify-content-between flex-wrap w-100 gap-5'>
                <div className='me-5' style={{flex: 1}}>
                  <CollapsibleCard title='Classificação' infoContent={productClassificationInfo}>
                    <div className='row g-4'>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          search
                          label={i18n.t(`smart_order.category`)}
                          options={categories}
                          value={subcategoryId}
                          change={(value: string) => {
                            setCanAlert(true)
                            setSubCategoryId(value)
                          }}
                          disabled={disableFieldsTotvs}
                        />
                      </div>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          label={i18n.t(`smart_order.mark`)}
                          options={marks}
                          value={markId}
                          change={(value: string) => {
                            setCanAlert(true)
                            setMarkId(value)
                          }}
                          disabled={disableFieldsTotvs}
                        />
                      </div>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          label={i18n.t(`smart_order.measurement_unit`)}
                          options={measurements}
                          value={measurementId}
                          change={(value: string) => {
                            setCanAlert(true)
                            setMeasurementId(value)
                          }}
                          disabled={disableFieldsTotvs}
                        />
                      </div>
                    </div>
                  </CollapsibleCard>

                  <CollapsibleCard title='Identificação' infoContent={productIdentificationInfo}>
                    <div className='row g-4'>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder={i18n.t(`smart_order.name`)}
                          label={i18n.t(`smart_order.name`)}
                          value={name}
                          change={(value: string) => {
                            setCanAlert(true)
                            setName(value)
                          }}
                          disabled={disableFieldsTotvs}
                          generateValueIA={
                            pluginIA && pluginIA !== ''
                              ? {
                                  modelId: pluginIA,
                                  prompt: `Corrija o nome do produto que estou passando colocando as primeiras letras em maiúsculas e o restante normal, não faça para preposições, nem para artigos. Segue o nome do produto: ${name}`,
                                  action: 'fix',
                                }
                              : undefined
                          }
                        />
                      </div>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder={i18n.t(`smart_order.code`)}
                          label={i18n.t(`smart_order.code`)}
                          value={code}
                          change={(value: string) => {
                            setCanAlert(true)
                            setCode(value)
                          }}
                          disabled={disableFieldsTotvs}
                        />
                      </div>
                    </div>
                  </CollapsibleCard>

                  <CollapsibleCard
                    title='Descrição e Conteúdo'
                    infoContent={productDescriptionInfo}
                  >
                    <div className='mb-3'>
                      <Input
                        inputAttr={{
                          type: 'textarea',
                        }}
                        placeholder={i18n.t(`smart_order.description`)}
                        label={i18n.t(`smart_order.description`)}
                        value={description}
                        change={(value: string) => {
                          setCanAlert(true)
                          setDescription(value)
                        }}
                        rows={5}
                        maxCaracteres={415}
                        disabled={disableFieldsTotvs}
                      />

                      {pluginIA && pluginIA !== '' && (
                        <div className='d-flex justify-content-start mt-2'>
                          <Button
                            text='Descrição Avançada com IA'
                            color='primary'
                            size='small'
                            horizontalPadding={3}
                            svgIcon={
                              <svg
                                width='15'
                                height='15'
                                viewBox='0 0 15 15'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                  fill='white'
                                />
                              </svg>
                            }
                            btnAttr={{
                              type: 'button',
                            }}
                            click={() => {
                              setShowDescriptionIAModal(true)
                            }}
                            btnClass='fw-bolder d-flex flex-row gap-1 align-items-center'
                            txtClass='text-nowrap text-white'
                            outline={false}
                            disabled={!name}
                          />
                        </div>
                      )}
                    </div>
                    <p className='mt-2'>
                      <small>
                        {description.length} {i18n.t(`smart_order.from`)} 415{' '}
                        {i18n.t(`smart_order.characters`)}
                      </small>
                    </p>

                    <Input
                      inputAttr={{
                        type: 'textarea',
                      }}
                      placeholder={i18n.t(`smart_order.technical_specification`)}
                      label={i18n.t(`smart_order.technical_specification`)}
                      value={technicalSpecification}
                      change={(value: string) => {
                        setCanAlert(true)
                        setTechnicalSpecification(value)
                      }}
                      rows={5}
                      maxCaracteres={415}
                      disabled={disableFieldsTotvs}
                    />
                    <p className='mt-2'>
                      <small>
                        {technicalSpecification.length} {i18n.t(`smart_order.from`)} 415{' '}
                        {i18n.t(`smart_order.characters`)}
                      </small>
                    </p>
                  </CollapsibleCard>

                  <CollapsibleCard title='Status e Ordenação' infoContent={productStatusInfo}>
                    <div className='row g-4'>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          label='Status'
                          options={[
                            {select: i18n.t(`general.active`), value: true},
                            {select: i18n.t(`general.inactive`), value: false},
                          ]}
                          value={status}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setStatus(value)
                          }}
                        />
                      </div>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder={i18n.t(`smart_order.order`)}
                          label={i18n.t(`smart_order.order`)}
                          smalltext='(para exibição no webapp)'
                          value={order}
                          change={(value: string) => {
                            setCanAlert(true)
                            setOrder(value)
                          }}
                          disabled={disableFieldsTotvs}
                        />
                      </div>
                    </div>
                  </CollapsibleCard>

                  {isWholeSaler && (
                    <CollapsibleCard
                      title='Data de Visualização para Venda'
                      infoContent={productVisibilityPeriodInfo}
                    >
                      <div className='mb-3'>
                        <Input
                          inputAttr={{
                            type: 'datetime-local',
                          }}
                          label='Data de Início da Venda'
                          placeholder='DD/MM/YYYY HH:MM'
                          value={saleDateStart}
                          change={(value: string) => {
                            setCanAlert(true)
                            setSaleDateStart(value)
                          }}
                        />
                        <small className='text-muted'>
                          Deixe vazio se o produto deve estar sempre visível a partir da data de
                          criação
                        </small>
                      </div>
                      <div className='mb-3'>
                        <Input
                          inputAttr={{
                            type: 'datetime-local',
                          }}
                          label='Data de Término da Venda'
                          placeholder='DD/MM/YYYY HH:MM'
                          value={saleDateEnd}
                          change={(value: string) => {
                            setCanAlert(true)
                            setSaleDateEnd(value)
                          }}
                        />
                        <small className='text-muted'>
                          Deixe vazio se o produto deve estar sempre visível sem limite de data
                        </small>
                      </div>
                    </CollapsibleCard>
                  )}

                  {isWholeSaler && (
                    <CollapsibleCard
                      title={i18n.t(`smart_order.product_groups`)}
                      infoContent={productGroupsInfo}
                    >
                      <div>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          isMulti
                          search
                          placeholder={i18n.t(`smart_order.product_groups`)}
                          label={i18n.t(`smart_order.product_groups`)}
                          value={groupsAssociated}
                          change={(selectedSeller: SelectType[]) => {
                            setGroupsAssociated(selectedSeller)
                          }}
                          options={groups.map((row) => {
                            return {
                              value: row.id,
                              select: row.name,
                            }
                          })}
                        />
                      </div>
                    </CollapsibleCard>
                  )}
                </div>

                <div className='product-image-column'>
                  <CollapsibleCard
                    title={i18n.t(`smart_order.product_image`)}
                    infoContent={productImageInfo}
                  >
                    <div className='d-flex justify-content-center w-100'>
                      <div className='px-10 py-5'>
                        {
                          /*
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      value={image}
                      change={(value: BaseSyntheticEvent) =>
                        setImage(value ? value.target.files[0] : null)
                      }
                    />
                    */
                          <>
                            <Input
                              inputAttr={{
                                type: 'image',
                              }}
                              action={() => {
                                showWrapperModal(i18n.t('smart_order.create_image_ia'))
                              }}
                              generateValueIA={
                                pluginIA && pluginIA !== ''
                                  ? {
                                      modelId: pluginIA,
                                      prompt: '',
                                      action: 'create',
                                    }
                                  : undefined
                              }
                              value={getImageForDisplay()}
                              change={(value: BaseSyntheticEvent) => {
                                setCanAlert(true)
                                setImage(value ? value.target.files[0] : null)
                                if (value) {
                                  getImagetoCrop(value ? value : null)
                                } else {
                                  setImageCrop('')
                                  getImagetoCrop(null)
                                }
                              }}
                            />
                          </>
                        }
                      </div>
                    </div>
                  </CollapsibleCard>

                  <CollapsibleCard title='Guia de Medidas' infoContent={productGuideInfo}>
                    <div className='card-body'>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        value={imageGuide}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setImageGuide(value ? value.target.files[0] : null)
                        }}
                      />
                      <div className='mt-4 pt-3' style={{borderTop: '1px solid #f1f1f2'}}>
                        <p className='fw-semibold fs-7 text-muted mb-3'>
                          Configure instruções do guia de medidas
                        </p>
                        <button
                          type='button'
                          className='btn btn-sm btn-light-primary fw-semibold w-100'
                          onClick={() => setShowMeasurementGuideModal(true)}
                        >
                          Configurar Guia de Medidas
                        </button>
                      </div>
                    </div>
                  </CollapsibleCard>

                  <CollapsibleCard
                    title={i18n.t(`smart_order.additional_images`)}
                    infoContent={productExtraImagesInfo}
                  >
                    <div className='d-flex justify-content-center w-100'>
                      <div className='px-10 py-5'>
                        <input
                          type='file'
                          accept='.jpg, .jpeg, .png'
                          multiple
                          onChange={(e) => {
                            if (
                              e.target.files &&
                              extraImagesUrl &&
                              e.target.files.length + extraImagesUrl?.length <= 3
                            ) {
                              setCanAlert(true)
                              setExtraImages(e.target.files)
                            } else {
                              e.target.value = ''
                              Swal.fire({
                                icon: 'warning',
                                title: 'Atenção!',
                                text: 'O limite de imagens adicionais é de no máximo 3 arquivos.',
                              })
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className='d-flex justify-content-center w-100 flex-wrap overflow-auto'
                      style={{maxHeight: '20rem'}}
                    >
                      {extraImagesUrl?.map((image) => {
                        return (
                          <div
                            className='px-10 py-5'
                            style={{position: 'relative', display: 'inline-block'}}
                          >
                            <div className='mt-1 w-150px'>
                              <div className='w-150px h-150px rounded position-relative'>
                                <img className='w-100 h-100' src={image.path} alt='' />
                                <span
                                  style={{
                                    position: 'absolute',
                                    top: 5,
                                    right: 5,
                                    cursor: 'pointer',
                                    width: 25,
                                    height: 25,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#fff',
                                    borderRadius: '50%',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                    zIndex: 2,
                                  }}
                                  className='btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow'
                                  data-action='remove'
                                  data-toggle='tooltip'
                                  title='Remover'
                                  onClick={() => deleteImages(image.id)}
                                >
                                  <i className='bi bi-x text-muted fs-1'></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                      {extraImages &&
                        Array.from(extraImages).map((image) => {
                          return (
                            <div className='px-10 py-5'>
                              <div className=' mt-1 w-150px'>
                                <div className='w-150px h-150px rounded'>
                                  <img
                                    className='w-100 h-100'
                                    src={URL.createObjectURL(image)}
                                    alt=''
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        })}
                    </div>
                  </CollapsibleCard>
                </div>
                <div className='card px-10 py-4 col-12 mb-5'>
                  <div className='d-flex justify-content-between w-100 '>
                    <Button
                      text={i18n.t(`buttons.back`)}
                      color='info'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        navigate(
                          `${
                            loginInfo.plugintype === 'varejo'
                              ? '/product_varejo'
                              : '/product_fashion'
                          }`
                        )
                      }}
                      btnClass='fw-bolder me-3'
                    />
                    <Button
                      text={i18n.t(`buttons.save`)}
                      color='primary'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        setCanAlert(false)
                        editProduct()
                      }}
                      btnClass='fw-bolder'
                    />
                  </div>
                </div>
              </div>

              <ModalWrapper
                confirmAction={() => {}}
                noCloseOverlay={true}
                noCloseButton={true}
                noAction={true}
                width={70}
                maxWidth
              >
                <ContentModalImageIA
                  key={'proposeImage'}
                  imageReferenceDefault={image}
                  description={description}
                  setImage={setImage}
                  imageIaSelected={imageIaSelected}
                  setImageIaSelected={setImageIaSelected}
                />
              </ModalWrapper>
            </div>
          </div>
        </div>
      )}

      {/* Modal IA para Descrição */}
      {showDescriptionIAModal && (
        <div className='modal-backdrop-custom'>
          <div className='modal-content-custom'>
            <ContentModalDescriptionIA
              description={description}
              productName={name}
              productImage={typeof image === 'string' ? image : null}
              pluginIA={pluginIA}
              onDescriptionGenerated={(generatedDescription: string) => {
                setDescription(generatedDescription)
                setShowDescriptionIAModal(false)
                setCanAlert(true)

                // Notificação de sucesso
                Swal.fire({
                  icon: 'success',
                  title: 'Descrição gerada!',
                  text: 'A descrição foi gerada com sucesso pela IA.',
                  timer: 2000,
                  showConfirmButton: false,
                })
              }}
              onCancel={() => setShowDescriptionIAModal(false)}
            />
          </div>
        </div>
      )}

      <ModalImagemCropped
        imageCrop={imageCrop}
        setCropper={setCropper}
        getCropData={getCropData}
        onUseOriginalImage={useOriginalImage}
        onUseSelectedSize={useSelectedSize}
      />

      <MeasurementGuideModal
        productId={id ?? ''}
        isOpen={showMeasurementGuideModal}
        onClose={() => setShowMeasurementGuideModal(false)}
      />
    </>
  )
}

const EditarProdutos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
          {
            title: i18n.t(`general.edit`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
        ]}
      >
        {`${i18n.t(`general.edit`)} ${i18n.t(`smart_order.product`)}`}
      </PageTitle>
      <EditarProdutosContent />
    </>
  )
}

export {EditarProdutos}
